<template>
  <v-select
    data-testid="yard-view-asset-container-status-select"
    :variant="null"
    :multiple="false"
    :items="containerStatuses"
    color="primary"
    item-title="title"
    :attrs="$attrs"
    density="compact"
    item-value="title"
    :model-value="containerStatus"
    :return-object="false"
    @update:model-value="handleValueUpdate"
    :clearable="false"
    hide-details>
    <template #selection="{ item }">
      <div style="margin-left: -18px">
        <yard-view-asset-container-status-chip
          :value="item.value"
          :title="t(`core.yard.assetContainerEvent.types.${camelCase(item.title)}`)" />
      </div>
    </template>
    <template #item="{ item, props }">
      <div v-bind="props" class="pa-2 pl-3 clickable">
        <yard-view-asset-container-status-chip :value="item.value" :title="item.title" />
      </div>
    </template>
  </v-select>
</template>

<script>
import { computed, defineComponent } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { AssetContainerEventType } from '@nova/core';
import YardViewAssetContainerStatusChip from '@/modules/yard/components/AssetContainer/YardViewAssetContainerStatusChip.vue';
import { camelCase } from 'lodash';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewAssetContainerStatusSelect',
  methods: { camelCase },
  emits: ['input'],
  components: {
    YardViewAssetContainerStatusChip
  },
  props: {
    containerStatus: {
      type: String,
      required: true
    },
    // Used for mixpanel event tracking
    assetContainer: {
      type: Object,
      required: true
    },
    // Used for mixpanel event tracking
    entryPoint: {
      type: String,
      required: false,
      default: () => 'Grid View'
    }
  },
  setup(props, { emit }) {
    const yardStore = useYard();
    const { t } = useI18n();

    const containerStatuses = computed(() => {
      return Object.entries(AssetContainerEventType)
        .filter(([value]) => value !== AssetContainerEventType.Departed)
        .map(([value, title]) => ({
          title: t(`core.yard.assetContainerEvent.types.${camelCase(title)}`),
          value
        }));
    });

    const handleValueUpdate = $event => {
      emit('input', $event);

      if ($event) {
        yardStore.trackMixpanelEvent(yardStore.MixPanelEvent.UPDATE_ASSET_CONTAINER_STATUS, {
          assetVisit: props.assetContainer,
          entryPoint: props.entryPoint,
          metadata: {
            asset_container_status_change: $event,
            drop_appointment_id: props.assetContainer?.dropAppointmentId,
            pickup_appointment_id: props.assetContainer?.pickupAppointmentId
          }
        });
      }
    };

    return {
      handleValueUpdate,
      containerStatuses,
      yardStore,
      t
    };
  }
});
</script>
